import { Card } from "@/components/ui/card";
import { CalendarRange, LineChart as LineIcon, CheckCircle2, ChevronRight } from "lucide-react";
import { getArea, ageString } from "./shared";
import { mediaUrl } from "@/lib/media";

export default function BepView({ student, bep, nav, range, onRange }) {
  if (!bep) return <div className="py-20 text-center text-sm text-slate-400" data-testid="parent-bep">Yükleniyor…</div>;
  const areas = bep.summary?.areas || [];

  return (
    <div data-testid="parent-bep">
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">BEP Planı</h1>
      <p className="mt-1 text-sm text-slate-500">Bireyselleştirilmiş Eğitim Programı</p>

      {student && (
        <Card className="mt-5 flex items-center gap-4 rounded-2xl border-slate-200/60 p-4 shadow-[0_2px_10px_rgba(0,0,0,0.04)]">
          <div className="relative">
            {student.photo_url ? <img src={mediaUrl(student.photo_url)} alt="" className="h-12 w-12 rounded-full object-cover" />
              : <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-violet-500 to-blue-600 font-bold text-white">{student.full_name.charAt(0)}</div>}
            <span className="absolute -bottom-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-emerald-400 text-white ring-2 ring-white"><CheckCircle2 className="h-3 w-3" /></span>
          </div>
          <div><p className="font-heading font-semibold text-slate-900">{student.full_name}</p><p className="text-sm text-slate-500">{ageString(student.birth_date)}</p></div>
        </Card>
      )}

      {range && (
        <div className="mt-3 flex flex-wrap items-center gap-2 rounded-xl bg-violet-50 px-3 py-2.5 text-sm font-medium text-violet-700" data-testid="bep-date-range">
          <CalendarRange className="h-4 w-4 flex-shrink-0" />
          <input type="date" value={range.start} onChange={(e) => onRange("start", e.target.value)} data-testid="bep-date-start"
            className="rounded-lg border border-violet-200 bg-white px-2 py-1 text-slate-700 outline-none focus:border-violet-400" />
          <span className="text-violet-400">–</span>
          <input type="date" value={range.end} onChange={(e) => onRange("end", e.target.value)} data-testid="bep-date-end"
            className="rounded-lg border border-violet-200 bg-white px-2 py-1 text-slate-700 outline-none focus:border-violet-400" />
        </div>
      )}

      <div className="mt-5 flex items-center justify-between">
        <h2 className="font-heading text-lg font-bold text-slate-900">Gelişim Alanları</h2>
        <span className="text-sm font-semibold text-violet-600">Toplam {bep.summary?.total_goals || 0} Hedef</span>
      </div>

      <button onClick={() => nav.goSub("chart")} data-testid="bep-open-chart"
        className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-violet-200 bg-white py-2.5 text-sm font-semibold text-violet-600 transition-colors hover:bg-violet-50">
        <LineIcon className="h-4 w-4" /> Gelişim Grafiğini Gör
      </button>

      <div className="mt-4 space-y-3">
        {areas.map((a) => {
          const meta = getArea(a.area);
          return (
            <Card key={a.area} data-testid={`bep-area-${a.area}`} onClick={() => nav.goSub({ type: "area", name: a.area })}
              className="cursor-pointer rounded-2xl border-slate-200/60 p-4 shadow-[0_2px_10px_rgba(0,0,0,0.04)] transition-transform hover:-translate-y-0.5 active:scale-[0.99]">
              <div className="flex items-center gap-3">
                <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${meta.bg}`}><meta.icon className={`h-5 w-5 ${meta.fg}`} /></div>
                <div className="flex-1"><p className="font-heading font-semibold text-slate-900">{a.area}</p></div>
                <span className="text-lg font-bold" style={{ color: a.color || meta.hex }}>%{a.avg_progress}</span>
                <ChevronRight className="h-5 w-5 text-slate-300" />
              </div>
              <div className="mt-3 h-2 overflow-hidden rounded-full bg-slate-100">
                <div className="h-full rounded-full" style={{ width: `${a.avg_progress}%`, backgroundColor: a.color || meta.hex }} />
              </div>
              <p className="mt-2 text-xs text-slate-400">{a.count} hedef</p>
            </Card>
          );
        })}
        {areas.length === 0 && (
          <Card className="rounded-2xl border-dashed p-14 text-center text-slate-400">Henüz BEP hedefi eklenmemiş.</Card>
        )}
      </div>
    </div>
  );
}
